// extracted by mini-css-extract-plugin
export default {"pill":"styles__pill___T45rg","yellow":"styles__yellow___qGVVU","green":"styles__green___VevdX","red":"styles__red___knJUL","blue":"styles__blue___uEQe1"};